import {
  CreateCustomerRequest,
  Customer,
  UpdateCustomerRequest,
} from '@interfaces/customer.interface';

import api from './';

export const {
  useGetCurrentCustomerQuery,
  useCreateCustomerMutation,
  useUpdateCurrentCustomerMutation,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentCustomer: builder.query<Customer, void>({
      query: () => ({ url: '/customers/me' }),
      providesTags: ['customer'],
    }),
    createCustomer: builder.mutation<Customer, CreateCustomerRequest>({
      query: ({ body, recaptchaToken }) => ({
        url: 'customers',
        method: 'POST',
        body,
        headers: {
          'x-grecaptcha': recaptchaToken,
        },
      }),
    }),
    updateCurrentCustomer: builder.mutation<Customer, UpdateCustomerRequest>({
      query: (body) => ({
        url: 'customers/me',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['customer'],
    }),
  }),
});
